<template>
  <!-- The gift's chips are tools (2026-10-27), never said as their words. The write-back
       is not a form here: the reply card is the one form (2026-10-22 §7); its
       chip opens it. The stars question is a link in the Mystic's line
       (a reply), never a chip; it starts Stage 3 in the conversation.
       Its own centred row across the chat, not a Mystic bubble: the bubble's
       gold-rule gutter pushed the chips off-centre (bug walk #1, #2). -->
  <div v-if="chips.length" class="gcb" :class="{ 'gcb-solo': chips.length === 1 }" data-testid="gift-chip-bar">
    <div class="gcb-row">
      <button
        v-for="c in chips"
        :key="c.key"
        type="button"
        class="gcb-chip"
        :class="{ primary: c.primary }"
        :data-testid="c.key"
        @click="emit('chip', c.key)"
      >
        <i v-if="c.icon" :class="['fas', c.icon]" aria-hidden="true"></i>{{ c.label }}
      </button>
    </div>
  </div>
</template>

<script setup>
defineProps({
  chips: { type: Array, default: () => [] },
})
const emit = defineEmits(['chip'])
</script>

<style scoped>
/* Chips are tools (Chris, 2026-10-27): Draw my card, Tell <sender> what it
   meant, Ask my own question, the Mirror. Plain, small, sentence case, one
   quiet row under the conversation, the same look as the chat's tool row. A
   question they would ask ("What do Sam's stars say about us?") is not here:
   it is a link in the Mystic's last line. The visible chip is 32px; its
   ::after reaches a 44px tap target. */
.gcb {
  display: block; width: 100%; max-width: 640px; box-sizing: border-box;
  margin: 12px auto; padding: 4px 0; align-self: center;
  background: transparent; box-shadow: none;
}
.gcb-row { display: flex; flex-wrap: wrap; gap: 10px 8px; justify-content: center; align-items: center; }
.gcb-chip {
  position: relative; display: inline-flex; align-items: center; gap: 6px;
  min-height: 32px; padding: 5px 12px; border-radius: 8px;
  background: rgba(255, 255, 255, 0.04); color: #ddd2f0;
  border: 1px solid rgba(233, 220, 255, 0.2);
  font-family: var(--cr-utility, inherit); font-size: 12.5px; font-weight: 500; line-height: 1.2;
  letter-spacing: 0.01em; text-transform: none; white-space: nowrap;
  cursor: pointer; transition: background 0.18s ease, border-color 0.18s ease, color 0.18s ease;
}
.gcb-chip::after { content: ''; position: absolute; inset: -6px -2px; }
.gcb-chip i { font-size: 11px; color: inherit; }
.gcb-chip:hover { background: rgba(255, 255, 255, 0.08); border-color: rgba(240, 217, 163, 0.45); color: #f0d9a3; }
/* The room's next act: the same chip, gold ink, no fill. */
.gcb-chip.primary { background: rgba(240, 217, 163, 0.06); border-color: rgba(240, 217, 163, 0.42); color: #f0d9a3; }
.gcb-chip:focus-visible { outline: 2px solid #FFDFA3; outline-offset: 2px; }
@media (max-width: 520px) {
  .gcb-chip { min-height: 34px; font-size: 13px; padding: 6px 12px; }
  .gcb-chip::after { inset: -5px -2px; }
}
</style>
